import { URLS } from '../../../constants';
import apiClient from '../../client';

const allClientTherapyApi = {
  getAllClientTherapy: () =>
    apiClient.post(URLS.clientTherapy, {
      data: {},
    }),
  getClientTherapyById: ({ childId }: { childId: any }) =>
    apiClient.post(URLS.clientTherapyById, {
      data: {
        childId,
      },
    }),
  getUnitAndVisit: ({
    clientId,
    useChildIdAndTherapy,
    therapyId,
  }: {
    clientId: any;
    useChildIdAndTherapy: any;
    therapyId: string;
  }) =>
    apiClient.post(URLS.unitAndVisit, {
      data: {
        clientId,
        useChildIdAndTherapy,
        therapyId,
      },
    }),
  getUnitAndVisitByClientId: ({
    clientId,
    useChildIdAndTherapy,
    therapyId,
  }: {
    clientId: any;
    useChildIdAndTherapy: any;
    therapyId: string;
  }) =>
    apiClient.post(URLS.unitAndVisitByClientId, {
      data: {
        clientId,
        useChildIdAndTherapy,
        therapyId,
      },
    }),
};

export default allClientTherapyApi;
